import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IAlertData } from '../typing/messages.interface';
import { Observable } from 'rxjs';
import { AlertTypeEnum } from '../ui-lib/alert-message/typing/alert-message.enum';
import { AlertMessageComponent } from '../ui-lib/alert-message/alert-message.component';
import { IPopUpWindowConfig } from '../typing/confirm-messages.interface';
import { MessageComponent } from '../ui-lib/confirm-messages/message.component';

@Injectable({
    providedIn: 'root',
})
export class MessageService {
    constructor(
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
    ) {}

    successMessage(message: string): void {
        const data: IAlertData = {
            message: message,
            type: AlertTypeEnum.success,
            icon: 'check_circle',
        };

        this.showSnackBarMessage(data);
    }

    warningMessage(message: string): void {
        const data: IAlertData = {
            message: message,
            type: AlertTypeEnum.warning,
            icon: 'warning',
        };
        this.showSnackBarMessage(data);
    }

    infoMessage(message: string): void {
        const data: IAlertData = {
            message: message,
            type: AlertTypeEnum.info,
            icon: 'info',
        };
        this.showSnackBarMessage(data);
    }

    errorMessage(message: string, closeButton = false): void {
        const data: IAlertData = {
            message: message,
            type: AlertTypeEnum.error,
            icon: 'error',
            closeButton
        };
        this.showSnackBarMessage(data);
    }

    confirmMessage(options?: IPopUpWindowConfig): Observable<boolean> {
        const config: IPopUpWindowConfig = {
            title: options?.title || 'Вы подтверждаете действие?',
            text: options?.text || '',
            primaryText: options?.primaryText || 'Да',
            secondaryText: options?.secondaryText || 'Нет',
            showSecondaryButton: options && options.showSecondaryButton !== undefined ? options.showSecondaryButton : true,
        };
        return this.openDialog(config);
    }

    private openDialog(options: IPopUpWindowConfig): Observable<boolean> {
        const dialogRef = this.dialog.open(MessageComponent, {
            maxWidth: '500px',
            width: '90%',
            minHeight: '150px',
            data: options,
            disableClose: true,
        });
        return dialogRef.afterClosed();
    }

    protected showSnackBarMessage(options: IAlertData): void {
        const duration = options.closeButton ? 60000 : 3000;
        this.snackBar.openFromComponent(AlertMessageComponent, {
            duration,
            data: options,
        });
    }
}
